(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("radiogroup", [], factory);
	else if(typeof exports === 'object')
		exports["radiogroup"] = factory();
	else
		root["radiogroup"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 